import { ComponentType, ReactNode, Suspense } from 'react';
import { Route } from 'react-router-dom';
import { PageLoadingComponent } from 'swo-ciam-common-react';

import { RouteConfig } from '@src/core/routing/types/route-config.interface';
import { CMPPermissions, CMPResourceGroup } from '@src/core/rbac/types/rbac-restriction.enum';
import { ProtectionWrapperComponent } from '@src/core/rbac/components/protection-wrapper.component';

export const routeComponentFactory = (
  route: RouteConfig,
  level = 0,
  parentResource?: CMPResourceGroup,
  parentPermission: CMPPermissions = CMPPermissions.FullAccess
): ReactNode => {
  const { isProtected = true, path, element, resource, permission, ...rest } = route;

  const Component = element as ComponentType;

  return (
    <Route
      {...rest}
      key={`${path}-routekey-${level}`}
      path={path}
      handle={{
        breadcrumb: route.breadcrumb,
      }}
      element={
        <Suspense key={`${route.path}-suspensekey-${level}`} fallback={<PageLoadingComponent />}>
          {isProtected ? (
            <ProtectionWrapperComponent
              resource={resource || parentResource}
              permission={permission || parentPermission}
            >
              <Component {...rest} />
            </ProtectionWrapperComponent>
          ) : (
            <Component {...rest} />
          )}
        </Suspense>
      }
    >
      {route.children &&
        route.children.map((childRoute) =>
          routeComponentFactory(childRoute, level + 1, parentResource || resource, parentPermission)
        )}
    </Route>
  );
};
